define.alias("ember-truth-helpers/helpers/is-empty", "settings/helpers/is-empty");